// External Portal v2 §4.2 / Phase 3 — generic "coming soon" empty
// state for tabs whose backend hasn't shipped yet. The tab strip
// surfaces the "Coming soon" pill on the spec entry (handled by the
// design-system Tabs primitive via the `comingSoon` flag); this
// component owns the panel body so the user sees what will live there
// once it's wired up.

interface PlaceholderTabProps {
  /** Heading inside the panel (matches the spec's §4.2 row label). */
  title: string;
  /** One-line description of what this surface will do once it ships. */
  description: string;
  /** Optional stable hook for tests / analytics. Defaults to a
   *  kebab-cased version of <c>title</c>. */
  testId?: string;
}

export function PlaceholderTab({ title, description, testId }: PlaceholderTabProps) {
  const resolvedTestId = testId ?? `placeholder-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
  return (
    <section
      aria-label={title}
      className="p-space-5 border border-dashed border-border-light rounded-md bg-white-pure"
      data-testid={resolvedTestId}
    >
      {/* §7 — the tab heading now lives in the shared PageHeader above this
          panel, so the placeholder body only carries the "Coming soon" pill
          and the one-liner on what will live here once it ships. */}
      <span
        className="text-caption uppercase tracking-wide text-gold-shadow"
        data-testid={`${resolvedTestId}-badge`}
      >
        Coming soon
      </span>
      <p className="text-small text-gray-mid mt-space-2">{description}</p>
    </section>
  );
}
